import { Button, Grid, TextField, MenuItem, DialogActions, Box, Typography, IconButton } from '@mui/material';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CustomerService from 'services/CustomerService';
import { AlertMessagesContext } from 'react-alert-messages';
import ShopsHelper from 'helpers/ShopsHelper';
import { InventoryContext } from 'Context/InventoryContext';
import { ShopContext } from 'Context/ShopContext';

export default function EditCustomerGroupDialog(props) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const { toggleEditTab, editData, getCustomerGroups } = props;
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const { shop } = useContext(ShopContext);
  const { priceCategories } = useContext(InventoryContext);

  const [name, setName] = useState(editData.name);
  const [description, setDescription] = useState(editData.description);
  const [priceCategory, setPriceCategory] = useState(editData?.price_category?.id);
  const [loadingIndicator, setLoadingIndicator] = useState(false);

  const handleUpdateCustomer = async () => {
    setLoadingIndicator(true);
    try {
      const data = {
        ...editData,
        name,
        description,
        price_category_id: priceCategory,
      };
      await CustomerService.updateCustomerGroups(editData.id, data);
      postAlertMessage({
        text: tPopup('Customer group updated successfully'),
        type: 'success',
      });
      getCustomerGroups();
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }
    setLoadingIndicator(false);
    toggleEditTab();
  };

  return (
    <>
      <Box className={styles.popUp}>
        <Box className={styles.contentWrapper}>
          <Box className={styles.headSec}>
            <Typography component="h2" className={styles.editTitle}>
              {tCommon('Edit Customer Group')}
            </Typography>
            <IconButton size="small" onClick={toggleEditTab}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Group ID')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label={tCommon('Group ID')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled
                  value={editData.id}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label="Name"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Description')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label={tCommon('Description')}
                  name="Description"
                  size="small"
                  variant="outlined"
                  fullWidth
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
            {ShopsHelper.hasProAccess(shop) && (
              <Grid container className={styles.inputRow} alignItems="center">
                <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                  <h3 className={styles.inputLabel}>{tCommon('Price Category')}</h3>
                </Grid>
                <Grid item xs={8} sm={8}>
                  <TextField
                    select
                    label={tCommon('Price Category')}
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="number"
                    value={priceCategory}
                    onChange={(e) => {
                      setPriceCategory(e.target.value);
                    }}
                  >
                    <MenuItem value={null}>None</MenuItem>
                    {priceCategories?.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            )}
          </Box>
          <Box className={styles.footSec}>
            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={toggleEditTab}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                disabled={name === '' || loadingIndicator}
                onClick={handleUpdateCustomer}
              >
                {tCommon('Update Group')}
              </Button>
            </DialogActions>
          </Box>
        </Box>
      </Box>
    </>
  );
}
